// extracted by mini-css-extract-plugin
export default {"rules":"rules_rules__CTces"};